import { attachment } from "./customer";

export default class Ticket {
  id = "";
  date = "";
  cust = "";
  desc = "";
  type = "";
  assigned_to = "";
  title = "";
  rate = "";
  closed = "";
  part = "";
  attachments_items: Array<attachment> = [];
  project_id = "";
  project_task = "";
  status = "";
  priority = "";
  conf_notes = "";
  cust_name?: string;
  project_title?: string;
  contact_items?: Array<contactItem>;
}

export interface ticketStatus {
  status_code: string;
  status_desc: string;
}

export interface ticketPriority {
  priority_code: string;
  priority_desc: string;
}

export interface contactItem {
  contact: string;
}
